const locale = {
	CONTACT: 'Contact',
	ISO: 'ISO 9001',
	MINERALS: 'Minerals Policy',
	PRODUCTS: 'Products',
	HOME: 'Home',
	footerCompany: 'QingYi Precision Co., Ltd.',
	footerTagline: 'Swiss-type CNC precision machining | φ1–20mm small-diameter parts, ±0.005mm tolerance, ISO 9001:2015 certified.',
	footerLinks: 'Quick Links',
	footerContactTitle: 'Contact',
	footerAddress: 'No. 5, Aly. 35, Ln. 1, Beinei St., Shulin Dist., New Taipei City, Taiwan',
	footerPhone: '+886-966-686-161 / +886-2-8687-2058',
	footerEmail: 'qingyi106@gmail.com',
	footerRights: '© 2026 QingYi Precision Co., Ltd. All rights reserved.'
};

export default locale;
